export interface IPMNoteModel {
    id: string;
    title: string;
    note: string;
    notes: string;
    workOrderId: string;
}

export class PMNoteModel implements IPMNoteModel {
    id: string = null;
    title: string = null;
    note: string = null;
    notes: string = null;
    workOrderId: string = null;
}
